import store from '@/store';
import { User } from '@/models/User';

// Group members and group-message creators carry only a userId. Resolve the FULL
// display User from the shared userStates cache (same source BCXAvatar and the
// banner use), keyed on the app-wide userId. Returning just firstname/lastname
// would drop company + city, so company users would show the contact person's
// name instead of the company name (and no location).
const userFromState = (userId: string): User => {
  const info = store.getters['userStates/getUserInfo'](userId);
  return { ...info, userId };
};

export default userFromState;
